import { __decorate, __metadata } from "tslib";
import { IsDateTimeFormat, WeekDayEnum, nameOf } from '@goparrot/common';
import { ApiExtraModels, ApiProperty, ApiPropertyOptional, refs } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ArrayNotEmpty, IsArray, IsBoolean, IsDate, IsEnum, IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, Min, ValidateNested } from 'class-validator';
import { PromotionExposeGroup, PromotionMustBuyConditionTypeEnum } from '../interface';
import { PutAbstractPromotionMustBuyConditionDto } from './PutAbstractPromotionMustBuyConditionDto';
import { PutPromotionCategoryMustBuyConditionDto } from './PutPromotionCategoryMustBuyConditionDto';
import { PutPromotionCombinationMustBuyConditionDto } from './PutPromotionCombinationMustBuyConditionDto';
import { PutPromotionItemMustBuyConditionDto } from './PutPromotionItemMustBuyConditionDto';
let PutPromotionConditionsDto = class PutPromotionConditionsDto {
};
__decorate([
    ApiPropertyOptional({
        type: () => String,
        isArray: true,
        description: '(applied when not empty) list of merchantUserId this promotion is restricted/limited to ',
        example: ['ccc84401-ccb3-423b-a8e1-a2a48f9580cc', '510125fc-7822-4ba4-b6ea-ffaf5f811138', '2c3bd825-e3fa-453c-b581-78ba3964d274'],
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    __metadata("design:type", Array)
], PutPromotionConditionsDto.prototype, "restrictedMerchantUserList", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'promotion is available only to users mentioned in ttl-users collection', example: true }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PutPromotionConditionsDto.prototype, "shouldCheckTtlUsers", void 0);
__decorate([
    ApiProperty({
        isArray: true,
        oneOf: refs(PutPromotionItemMustBuyConditionDto, PutPromotionCategoryMustBuyConditionDto, PutPromotionCombinationMustBuyConditionDto),
        description: 'list of promotion conditioned targets',
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => PutAbstractPromotionMustBuyConditionDto, {
        discriminator: {
            property: nameOf('type'),
            subTypes: [
                { name: PromotionMustBuyConditionTypeEnum.ITEM, value: PutPromotionItemMustBuyConditionDto },
                { name: PromotionMustBuyConditionTypeEnum.CATEGORY, value: PutPromotionCategoryMustBuyConditionDto },
                { name: PromotionMustBuyConditionTypeEnum.COMBINATION, value: PutPromotionCombinationMustBuyConditionDto },
            ],
        },
        keepDiscriminatorProperty: true,
    }),
    IsArray({ always: true }),
    ValidateNested({ always: true, each: true }),
    __metadata("design:type", Array)
], PutPromotionConditionsDto.prototype, "storeItemsList", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: '(applied when >0) stands for maximum number of usages of that promotion per userId ', example: 1 }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsInt({ always: true }),
    Min(0, { always: true }),
    __metadata("design:type", Number)
], PutPromotionConditionsDto.prototype, "maxUsagesPerUser", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: '(applied when >0) stands for maximum number of usages of that promotion per cart ', example: 1 }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsInt({ always: true }),
    Min(0, { always: true }),
    __metadata("design:type", Number)
], PutPromotionConditionsDto.prototype, "maxUsagesPerCart", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: '(applied when >0) stands for exact number of "old, completed" orders for userId ' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], PutPromotionConditionsDto.prototype, "onOrderCount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: '(applied when >0) exclusive-minimum subtotal of order ' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], PutPromotionConditionsDto.prototype, "minOrderValue", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => String,
        description: 'if provided - will be added to order on vendor-v2 side as free item instead of promotion (replacing)',
        example: '0147535f-3800-4630-a309-1f3c2a88e829',
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], PutPromotionConditionsDto.prototype, "freeStoreItemUniqueName", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Date,
        description: '(applied when not empty) promotion starting date, inclusive',
        example: '2017-08-13T09:40:12.925+0000',
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => Date),
    IsOptional({ always: true }),
    IsDate({ always: true }),
    __metadata("design:type", Date)
], PutPromotionConditionsDto.prototype, "startDate", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Date,
        description: '(applied when not empty) promotion ending date, inclusive',
        example: '2019-09-13T09:40:12.925+0000',
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => Date),
    IsOptional({ always: true }),
    IsDate({ always: true }),
    __metadata("design:type", Date)
], PutPromotionConditionsDto.prototype, "endDate", void 0);
__decorate([
    ApiPropertyOptional({ enum: WeekDayEnum, description: 'week days when promotion is on', example: [WeekDayEnum.SAT, WeekDayEnum.SUN] }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsEnum(WeekDayEnum, { each: true, always: true }),
    IsOptional({ always: true }),
    ArrayNotEmpty({ always: true }),
    __metadata("design:type", Array)
], PutPromotionConditionsDto.prototype, "weekdays", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'time range during the day', example: '10:00/19:00' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    IsDateTimeFormat({ format: 'HH:mm', isInterval: true }, { always: true }),
    __metadata("design:type", String)
], PutPromotionConditionsDto.prototype, "timeRange", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'should paid modifiers be discounted', example: true }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PutPromotionConditionsDto.prototype, "appliesToModifiers", void 0);
PutPromotionConditionsDto = __decorate([
    ApiExtraModels(PutPromotionItemMustBuyConditionDto, PutPromotionCategoryMustBuyConditionDto, PutPromotionCombinationMustBuyConditionDto)
], PutPromotionConditionsDto);
export { PutPromotionConditionsDto };
//# sourceMappingURL=PutPromotionConditionsDto.js.map